import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { LoginFailedComponent } from './core/login-failed/login-failed.component';
import { DevelopmentComponent } from './development/development.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RestrictComponent } from './restrict/restrict.component';

const routes: Routes = [
	{
		path: '',
		loadChildren: () =>
			import('./modules/starter/starter.module').then(
				(m) => m.StarterModule,
			),
		canActivate: [MsalGuard],
	},
	{
		path: 'login-failed',
		component: LoginFailedComponent,
	},
	{
		path: '404',
		component: NotFoundComponent,
	},
	{
		path: 'development',
		component: DevelopmentComponent,
	},
	{
		path: 'restrict',
		component: RestrictComponent,
	},
	{
		path: '**',
		redirectTo: '/404',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
